import { randomHeaderImage } from './randomHeaderImage'
import { getHeaderBackground } from './getHeaderBackground'

if (myPix) {
    randomHeaderImage(myPix);
}
getHeaderBackground()
